import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { contentOptimizerContentTabValues } from '../../components/pages/contentOptimizer/contentPage/contentOptimizerContentConstants';
import { setContentOptimizerTabKey } from '../../components/pages/contentOptimizer/mainPage/store/contentOptimizerMain.actions';
import { contentOptimizerLSTabKey } from '../../constants/contentOptimizer';

export const useMoveToOptimizerTab = (moveToDefault = false) => {
    const dispatch = useDispatch();
    const [isMoveToOptimizerTab, setMoveToOptimizerTab] =
        useState(moveToDefault);

    const goToOptimizerTab = useCallback(() => {
        const tabKeyValue = contentOptimizerContentTabValues.optimizer.value;

        localStorage.setItem(contentOptimizerLSTabKey, tabKeyValue);
        dispatch(setContentOptimizerTabKey(tabKeyValue));

        setMoveToOptimizerTab(false);
    }, [dispatch]);

    useEffect(() => {
        if (isMoveToOptimizerTab) {
            goToOptimizerTab();
        }
    }, [isMoveToOptimizerTab, goToOptimizerTab]);

    return [isMoveToOptimizerTab, setMoveToOptimizerTab];
};

export default useMoveToOptimizerTab;
